import React from "react";
import classNames from "classnames";
export const Spinner = (props) => {
    return (React.createElement("div", { className: "spinner-block" },
        React.createElement("div", { className: classNames("ispinner", { "ispinner-large": props.large }) },
            React.createElement("div", { className: "ispinner-blade" }),
            React.createElement("div", { className: "ispinner-blade" }),
            React.createElement("div", { className: "ispinner-blade" }),
            React.createElement("div", { className: "ispinner-blade" }),
            React.createElement("div", { className: "ispinner-blade" }),
            React.createElement("div", { className: "ispinner-blade" }),
            React.createElement("div", { className: "ispinner-blade" }),
            React.createElement("div", { className: "ispinner-blade" }),
            React.createElement("div", { className: "ispinner-blade" }),
            React.createElement("div", { className: "ispinner-blade" }),
            React.createElement("div", { className: "ispinner-blade" }),
            React.createElement("div", { className: "ispinner-blade" }))));
};
